import * as React from "react";
import { Text } from "office-ui-fabric-react";
import { saveAs } from "file-saver";
import { IDataProvider } from "../../dataprovider/IDataProvider";

interface IProcessStep {
  step: string;
  title: string;
  description: string;
}

const processSteps: IProcessStep[] = [
  { step: "1", title: "Create Account", description: "Receive activation email" },
  { step: "2", title: "Complete Legal Requirements", description: "Signed form (NDA)" },
  { step: "3", title: "Straumann Review", description: "Verification and confirmation via email" },
  { step: "4", title: "Download STL", description: "File access" },
];

interface IProcessStepsProps {
  dataProvider: IDataProvider;
}

export const ProcessSteps = (props: IProcessStepsProps): React.ReactElement => {
  const [isDownloading, setIsDownloading] = React.useState(false);

  const downloadAgreementForm = async (): Promise<void> => {
    try {
      setIsDownloading(true);
      const response = await props.dataProvider.downloadAgreementForm();
      const file = JSON.parse(response);
      const fileResponse = await fetch(`data:application/pdf;base64,${file.FileContents}`);
      saveAs(await fileResponse.blob(), file.FileDownloadName);
    } catch (error) {
      window.alert(typeof error === "string" ? error : "The agreement form could not be downloaded.");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="welcomeStepsSection">
      <div className="welcomeStepsGrid">
        {processSteps.map((item, index) => (
          <div key={item.step} className="welcomeStepCard">
            <div className="welcomeStepHeader">
              <div className="welcomeStepNumber">{item.step}</div>
              {index < processSteps.length - 1 && <div className="welcomeStepConnector" aria-hidden="true" />}
            </div>
            <Text variant="large" className="welcomeStepTitle">
              {item.title}
            </Text>
            <Text variant="medium" className="welcomeStepDescription">
              {item.step === "2" ? (
                <button type="button" className="welcomeAgreementLink" onClick={downloadAgreementForm} disabled={isDownloading}>
                  {isDownloading ? "Downloading form..." : item.description}
                </button>
              ) : (
                item.description
              )}
            </Text>
          </div>
        ))}
      </div>
    </div>
  );
};
